import React from 'react';

import styles from './kanban-card-action.module.scss';
interface KanbanCardActionProps {
  icon: React.ReactElement;
  onClick: (e: React.MouseEvent) => void;
  text?: string;
}

export const KanbanCardAction: React.FC<KanbanCardActionProps> = ({ icon, onClick, text }) => (
  <div className={styles['container']} onClick={onClick}>
    {icon}
    {text && <span className="caption">{text}</span>}
  </div>
);
